import React from 'react';
import classNames from 'classnames';

import css from './Tooltip.module.css';

const Tooltip = props => {
  const { className, text = '', content = '', side = 'top', isOtherCalendarBtn = false } = props;

  const wrapperStyles = classNames(css.wrapper, className, {
    [css.wrapperOtherCalendarBtn]: isOtherCalendarBtn,
  });
  const contentStyles = classNames(css.content, {
    [css.contentOtherCalendarBtn]: isOtherCalendarBtn,
  });
  const arrowStyles = classNames(css.arrow, {
    [css.arrowOtherCalendarBtn]: isOtherCalendarBtn,
  });

  return (
    <span className={wrapperStyles} data-side={side}>
      {text}
      <span className={contentStyles}>
        <p>{content}</p>
        <span className={arrowStyles} />
      </span>
    </span>
  );
};

export default Tooltip;
